import React from 'react';
import styled from 'styled-components';
import InputGroupText from 'components/atoms/form/InputGroupText';


const getPrimaryColor = props =>
    (props.meta.error ? props.theme.colors.error : props.theme.colors.primary);

const getSecondaryColor = props =>
    (props.meta.error ? props.theme.colors.error : props.theme.colors.darkgray); // TODO ML-166, add to theme


const InputWrapper = styled.div`
    display: ${props => (props.hidden ? 'none' : 'flex')};
    justify-content: flex-start;
    align-items: center;
    position: relative;
    font-family: 'Lato', sans-serif;
    font-size: 1em;
    margin-bottom: 4px;
    width: 100%;
    height: 55px;

    & input {
        display: inline-block;
        background-color: rgba(255,255,255,1);
        font-size: inherit;
        width: 100%;
        border: 1px solid ${props => getSecondaryColor(props)};
        padding: .80em;
        color: #000;
    }

    & input:required {
        box-shadow: none;
    }

    & input:-webkit-autofill {
        box-shadow: 0 0 0 30px rgba(255,255,255,1) inset;
    }

    & input:focus {
        border-color: ${props => getPrimaryColor(props)};
        border-width: 2px;
    }

    & input:focus + div label {
        color:  ${props => getPrimaryColor(props)};
    }

    & input:disabled {
        color: #cbcbcb;
        cursor: not-allowed;
    }

    & *:focus {
        outline: 0;
    }
`;

const TextInputAdmin = ({ input = {}, name, type, disabled = false, meta = {}, required = true, placeholder, autocomplete = 'on', inputGroupTextAppend, inputGroupTextPrepend, hidden }) => {
    const hasValue = input.value && input.value.length > 0;
    return (
        <InputWrapper meta={meta} hidden={hidden}>
            {inputGroupTextPrepend ? <InputGroupText>{inputGroupTextPrepend}</InputGroupText> : null}
            <input {...input}
                className={hasValue ? 'has-value' : ''}
                name={name}
                type={type}
                required={required}
                disabled={disabled}
                placeholder={placeholder}
                autoComplete={autocomplete} />
            {inputGroupTextAppend ? <InputGroupText>{inputGroupTextAppend}</InputGroupText> : null}
        </InputWrapper>
    );
};

export { TextInputAdmin as default };



// WEBPACK FOOTER //
// ./src/components/atoms/inputs/TextInputAdmin.js